import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: false,
    loadingCalendar: false,
    requireCalendarReload: false,
}

export const loadingDateSlice: any = createSlice({
    name: 'LOADING_DATE',
    initialState,
    reducers: {
        setLoadingDate: (state: any, action: any) => {
            state.value = action.payload
        },
        setLoadingCalendar: (state: any, action: any) => {
            state.loadingCalendar = action.payload
        },
        setRequireCalendarReload: (state: any, action: any) => {
            state.requireCalendarReload = action.payload
        },
    },
})

export const { setLoadingDate, setLoadingCalendar, setRequireCalendarReload } = loadingDateSlice.actions

export default loadingDateSlice.reducer
